import React from 'react';
import { Fab } from '@mui/material';
import { ChatBubbleOutline as ChatIcon } from '@mui/icons-material';
import { useFeedback } from '../../contexts/FeedbackContext';

const FAB_SIZE = 44;

function FeedbackFAB() {
  const { openPanel } = useFeedback();

  return (
    <Fab
      aria-label="Open feedback"
      onClick={openPanel}
      sx={{
        position: 'fixed',
        bottom: { xs: 84, sm: 22 },
        right: { xs: 18, sm: 22 },
        width: FAB_SIZE,
        height: FAB_SIZE,
        borderRadius: '50%',
        color: 'var(--vera-ink)',
        backgroundColor: 'rgba(255,255,255,0.88)',
        border: '1px solid rgba(134, 170, 196, 0.42)',
        boxShadow: '0 8px 20px rgba(11, 32, 56, 0.10)',
        '&:hover': {
          boxShadow: '0 12px 26px rgba(11, 32, 56, 0.14)',
          backgroundColor: 'rgba(232, 239, 243, 0.96)',
          transform: 'translateY(-1px)',
        },
        transition: 'box-shadow 200ms ease, background-color 160ms ease, transform 160ms ease',
        zIndex: 1300,
      }}
    >
      <ChatIcon />
    </Fab>
  );
}

export default FeedbackFAB;
